function getCookie(name: string): string | undefined {
  const match = document.cookie.match(
    new RegExp(
      '(^|;\\s*)' +
        name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') +
        '=([^;]*)'
    )
  );
  return match ? decodeURIComponent(match[2]) : undefined;
}

export function csrfHeaders(): Record<string, string> {
  const token = getCookie('XSRF-TOKEN');

  return token ? { 'X-XSRF-TOKEN': token } : {};
}
